import Text, { TextProps } from './Text';

export type { TextProps };
export default Text;
